<template>
  <section v-if="show" class="info-footer-row-container">
    <div class="info-footer-row">
      <h4 class="headline">{{ $t('home.row-info-footer') }}</h4>
      <join-us-button />
    </div>
  </section>
</template>

<script>
import firebase from 'firebase/app';

import JoinUsButton from '@/components/common/JoinUsButton.vue';

export default {
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    JoinUsButton,
  },
  computed: {
    user() {
      return firebase.auth().currentUser;
    },
    show() {
      return this.enabled || !this.user;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.info-footer-row-container {
  width: 100%;
  min-height: 112px;
  background-color: $blue;
  display: flex;
  justify-content: center;
}

.info-footer-row {
  width: $page-laptop-breakpoint;
  padding: 0 $home-container-horizontal-padding;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.headline {
  color: $white;
}

@media (max-width: $page-laptop-breakpoint) {
  .info-footer-row {
    max-width: $page-table-breakpoint;
  }

  .headline {
    font-size: $font-size-headline-small;
  }
}

@media (max-width: $page-table-breakpoint) {
  .info-footer-row {
    max-width: $page-mobile-large-breakpoint;
    flex-direction: column;
    padding: 10px 0;
  }

  .headline {
    text-align: center;
  }
}

@media (max-width: $page-mobile-large-breakpoint) {
  .info-footer-row {
    max-width: $page-mobile-small-breakpoint;
  }
}
</style>
